import React, {useState} from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, {dateFilter, textFilter, numberFilter, Comparator} from 'react-bootstrap-table2-filter';
import ToolkitProvider, {ColumnToggle} from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Moment from "moment";
import {Button} from "react-bootstrap";

// at December 9th, 2020, Metalac decided to allow only one stamp per day.
const whenNewLogicForStampsApplied = new Date(2020, 11, 9);
// One day in milliseconds
const oneDayInMilliseconds = 1000 * 60 * 60 * 24;

const MyExportCSV = (props) => {
    const handleClick = () => {
        props.onExport();
    };
    return (
        <div className="col-md-4 center">
            <button className="btn btn-success" onClick={handleClick}>Export Visible Data To File</button>
        </div>
    );
};

const {ToggleList} = ColumnToggle;

let scanDateRangeConst = {};

export const Scans = ({scans, company, allScans, scanDateRange, page, setPage, filter, setFilter, fetchScansByUids}) => {
    const [uidSearchInput, setUidSearchInput] = useState('');
    const [isSearching, setIsSearching] = useState(false);

    const handleUidSearch = async () => {
        if (!uidSearchInput.trim() || !fetchScansByUids) return;

        const uids = uidSearchInput.split(',')
            .map(uid => uid.trim())
            .filter(uid => uid.length > 0);

        if (uids.length === 0) return;

        setIsSearching(true);
        try {
            await fetchScansByUids(uids);
        } finally {
            setIsSearching(false);
        }
    };

    const columns = [{
        dataField: 'index',
        text: 'Index',
        sort: true
    }, {
        dataField: 'uid',
        text: 'Uid',
        filter: textFilter({
            defaultValue: filter instanceof Map && filter.has("uid") ? filter.get("uid") : '',
            onFilter: (filterValue) => { setFilter("uid", filterValue)}
        }),
        sort: true
    }, {
        dataField: 'totalValue',
        text: 'Total',
        filter: numberFilter({
            defaultValue: {number: 0, comparator: Comparator.GT}
        }),
        sort: true
    }, {
        dataField: 'valueInLastBonusPeriod',
        text: 'Value in Bonus Period',
        filter: numberFilter({
            defaultValue: {number: 0, comparator: Comparator.GT}
        }),
        sort: true
    }, {
        dataField: 'value',
        text: 'Value',
        sort: true,
        filter: numberFilter({
            defaultValue: {number: 0, comparator: Comparator.GT}
        }),
        hidden: true,
    }, {
        dataField: 'uidForScanFrequency',
        text: 'Scan Frequency',
        filter: numberFilter({
            defaultValue: {comparator: Comparator.GT}
        }),
        filterValue: scanFrequencyFormatter,
        sortValue: scanFrequencyFormatter,
        formatter: scanFrequencyFormatter,
        csvFormatter: scanFrequencyFormatter,
        sort: true
    }, {
        dataField: 'visits',
        text: 'Visits',
        filter: numberFilter({
            defaultValue: {number: 0, comparator: Comparator.GT}
        }),
        hidden: false,
        sort: true
    }, {
        dataField: 'visitNum',
        text: 'Visit Number',
        filter: numberFilter({
            defaultValue: {number: 0, comparator: Comparator.GT}
        }),
        hidden: true,
    }, {
        dataField: 'periodFilled',
        text: '# Bonus',
        filter: numberFilter({
            defaultValue: {number: 0, comparator: Comparator.GT}
        }),
        hidden: true,
    }, {
        dataField: 'billNumber',
        text: 'Bill Number',
        sort: true,
        filter: textFilter(),
        hidden: true,
    }, {
        dataField: 'country',
        text: 'Country',
        sort: true,
        hidden: true,
        filter: textFilter()
    }, {
        dataField: 'city',
        text: 'City',
        sort: true,
        filter: textFilter()
    }, {
        dataField: 'companyCode',
        text: 'Company',
        sort: true,
        hidden: true,
        filter: textFilter()
    }, {
        dataField: 'storeId',
        text: 'Store Id',
        sort: true,
        filter: textFilter(),
        hidden: true,
    }, {
        dataField: 'voucher',
        text: 'Voucher',
        sort: true,
        hidden: true,
        filter: textFilter()
    },{
        dataField: 'posId',
        text: 'Pos Id',
        sort: true,
        hidden: true,
        filter: textFilter()
    }, {
        dataField: 'status',
        text: 'Status',
        hidden: true,
        sort: true,
        filter: textFilter()
    }, {
        dataField: 'username',
        text: 'Username',
        hidden: true,
        sort: true,
        filter: textFilter()
    }, {
        dataField: 'items',
        text: 'Items',
        hidden: true,
        sort: true,
        filter: textFilter(),
        formatter: lineFormatter
    },{
        dataField: 'time',
        hidden: true,
        sort: true,
        text: 'Time'
    }, {
        dataField: 'timestamp',
        text: 'Date',
        filter: dateFilter({
            defaultValue: filter instanceof Map && filter.has("timestamp") ? filter.get("timestamp") : {},
            onFilter: (filterValue) => { setFilter("timestamp", filterValue)}
        }),
        formatter: dateFormatter,
        csvFormatter: dateFormatter,
        sort: true
    }, {
        dataField: 'timestamp1',
        text: 'Date Again',
        filter: dateFilter({
            defaultValue: filter instanceof Map && filter.has("timestamp1") ? filter.get("timestamp1") : {},
            onFilter: (filterValue) => { setFilter("timestamp1", filterValue)}
        }),
        formatter: dateFormatter,
        csvFormatter: dateFormatter,
        sort: true
    }, {
        dataField: 'scanTimeDiff',
        text: 'Seconds to Scan',
        hidden: false,
        filter: numberFilter({
            defaultValue: {number: 0, comparator: Comparator.GT}
        }),
        formatter: scanTimeDiffHumanFormatFormatter,
        csvFormatter: scanTimeDiffFormatter,
        filterValue: scanTimeDiffFormatter,
        sort: true
    }];

    function scanTimeDiffFormatter(cell, row) {
        if (cell === null) {
            return -1;
        }
        return cell;
    }

    function scanTimeDiffHumanFormatFormatter(cell, row) {
        if (cell === null) {
            return -1;
        }
        return secondsToHms(cell);
    }

    function secondsToHms(d) {
        d = Number(d);
        const h = Math.floor(d / 3600);
        const m = Math.floor(d % 3600 / 60);
        const s = Math.floor(d % 3600 % 60);
        const timeElements = [];
        if (h > 0) timeElements.push(h + "h");
        if (m > 0) timeElements.push(m + "m");
        if (s > 0) timeElements.push(s + "s");
        return timeElements.join(':');
    }

    function dateFormatter(cell, row) {
        return Moment.tz(cell, 'Europe/Belgrade').format('DD.MM.YYYY');
    }

    function lineFormatter(cell, row) {
        if (!cell || typeof cell !== 'string') {
            return '';
        }

        // Split the string by '; ' delimiter
        const items = cell.split('; ');

        // Return JSX with each item on a separate line
        return (
            <div>
                {items.map((item, index) => (
                    <div key={index}>{item.trim()}</div>
                ))}
            </div>
        );
    }

    function scanFrequencyFormatter(cell, row) {
        if (typeof scanDateRangeConst[cell] === "undefined") {
            return -1;
        }
        const diffInTime = scanDateRangeConst[cell].endTime.toDate().getTime() - scanDateRangeConst[cell].startTime.toDate().getTime();
        const diffInDays = Math.round(diffInTime / oneDayInMilliseconds) + 1;
        return Math.round((scanDateRangeConst[cell].visitCount / diffInDays) * 1000) / 1000;
    }

    scanDateRangeConst = scanDateRange;
    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            // alert("Row index: " + (rowIndex + 1));
        }
    };

    const onPageChange = (num) => {
        setPage(num);
    }

    const options = {
        page: page,
        sizePerPageList: [{text: '50', value: 50}, {text: '100', value: 100}, {text: '250', value: 250}, {
            text: 'All',
            value: scans.length
        }],
        onPageChange: onPageChange,
        showTotal: true
    }

    return (
        <ToolkitProvider
            keyField='index'
            data={scans}
            columns={columns}
            columnToggle
            pagination={paginationFactory(options)}
            exportCSV={{
                exportAll: false,
                onlyExportFiltered: true
            }}>
            {props => (
                <div>
                    {/* UID Search Section */}
                    {fetchScansByUids && (
                        <div className="p-4 mb-4 bg-gray-100 rounded-lg border border-gray-200">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Pretrazi po UID-ovima (razdvojeni zarezom):
                            </label>
                            <div className="flex flex-wrap items-center gap-3">
                                <input
                                    type="text"
                                    className="flex-1 min-w-64 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholder="uid1, uid2, uid3..."
                                    value={uidSearchInput}
                                    onChange={(e) => setUidSearchInput(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && handleUidSearch()}
                                />
                                <Button
                                    variant="outline-primary"
                                    onClick={handleUidSearch}
                                    disabled={isSearching || !uidSearchInput.trim()}
                                >
                                    {isSearching ? 'Trazim...' : 'Pretrazi'}
                                </Button>
                            </div>
                        </div>
                    )}
                    <hr/>
                    <MyExportCSV {...props.csvProps}/>
                    <hr/>
                    <ToggleList {...props.columnToggleProps} />
                    <hr/>
                    <BootstrapTable striped bordered hover {...props.baseProps}
                                    pagination={paginationFactory(options)}
                                    rowEvents={rowEvents}
                                    bootstrap4={true}
                                    tabIndexCell
                                    filter={filterFactory()}
                    />
                </div>
            )
            }
        </ToolkitProvider>
    )
}